import { useEffect } from 'react';

export function useDocumentTitle(title: string): void {
  useEffect(() => {
    const previous = document.title;
    document.title = title ? `${title} · AdVolt Admin` : 'AdVolt Admin';
    return () => {
      document.title = previous;
    };
  }, [title]);
}
